export default function isMobile(){
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}



// WEBPACK FOOTER //
// ./src/lib/isMobile.js